export default {
	text: 'Вы используете устаревшую версию сайта.\nОбновите страницу.',
	reconnecting: 'Подождите, идет подключение к серверу',
	btn: 'Обновить',
}
